import React__default from 'react';
import moment from 'moment';
import AutoCompleteDropdown from '../AutoCompleteDropdown/AutoCompleteDropdown.js';

/* eslint-disable react/button-has-type */
/* eslint-disable react/prop-types */

// eslint-disable-next-line react/prop-types
const range = (start, end) => Array.from({
  length: end - start + 1
}, (_, i) => start + i);
function DatePickerCusstomHeader(_ref) {
  let {
    date,
    changeYear,
    changeMonth,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled
  } = _ref;
  const years = range(1990, moment().year() + 1);
  const yearOptions = years.map(year => ({
    value: year,
    label: year.toString()
  }));
  const months = moment.months();
  const monthOptions = months.map((month, index) => ({
    value: index,
    label: month
  }));
  return /*#__PURE__*/React__default.createElement("div", {
    className: "calendar-header"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "month-prev-btn",
    onClick: decreaseMonth,
    disabled: prevMonthButtonDisabled
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_arrowLineLeft font-size-12"
  })), /*#__PURE__*/React__default.createElement("span", {
    className: "select-container"
  }, /*#__PURE__*/React__default.createElement(AutoCompleteDropdown, {
    options: monthOptions,
    size: "medium",
    value: monthOptions.find(option => {
      const dateObj = date ? moment(date) : null; // timestamp -> moment
      return dateObj && option.value === dateObj.month();
    }),
    onChange: selectedOption => changeMonth(selectedOption.target.value.value),
    style: {
      width: '140px'
    }
  }), /*#__PURE__*/React__default.createElement(AutoCompleteDropdown, {
    options: yearOptions,
    size: "medium",
    value: yearOptions.find(option => {
      const dateObj = date ? moment(date) : null; // timestamp -> moment
      return dateObj && option.value === dateObj.year();
    }),
    onChange: selectedOption => changeYear(selectedOption.target.value.value),
    isOptionEqualToValue: (option, value) => option.value === value.value,
    style: {
      width: '95px'
    }
  })), /*#__PURE__*/React__default.createElement("button", {
    className: "month-next-btn",
    onClick: increaseMonth,
    disabled: nextMonthButtonDisabled
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_arrowLineRight font-size-12"
  })));
}
export { DatePickerCusstomHeader as default };